// extracted by mini-css-extract-plugin
export default {"footerUl":"Footer_footerUl__BOa4R"};